import { validatePhoneNumber } from '../../lib/funnels/functions/v1/formats/validatePhoneNumber.js'
import { validateEmail } from '../../lib/funnels/functions/v1/formats/validateEmail.js'
import { showInputError } from '../../lib/funnels/functions/v1/html/showInputError.js'
import { hideInputError } from '../../lib/funnels/functions/v1/html/hideInputError.js'
import { setUpFormInputs } from '../../lib/funnels/functions/v1/html/setupFormInputs.js'

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Set up form inputs (phone mask, validation, etc.)
  setUpFormInputs()

  const form = document.getElementById('optin-form')

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault()

      // Get form elements
      const nameElement = /** @type {HTMLInputElement} */ (
        document.getElementById('name')
      )
      const emailElement = /** @type {HTMLInputElement} */ (
        document.getElementById('email')
      )
      const phoneElement = /** @type {HTMLInputElement} */ (
        document.getElementById('phone')
      )
      const smsConsentElement = /** @type {HTMLInputElement} */ (
        document.getElementById('smsConsent')
      )
      const termsConsentElement = /** @type {HTMLInputElement} */ (
        document.getElementById('termsConsent')
      )

      let hasErrors = false

      // Validate Name
      if (!nameElement?.value.trim()) {
        if (nameElement) {
          nameElement.setAttribute(
            'data-error-message',
            'Please enter your full name',
          )
          showInputError(nameElement)
          hasErrors = true
        }
      } else if (nameElement) {
        hideInputError(nameElement)
      }

      // Validate Email
      if (!emailElement?.value.trim()) {
        if (emailElement) {
          emailElement.setAttribute(
            'data-error-message',
            'Please enter your email address',
          )
          showInputError(emailElement)
          hasErrors = true
        }
      } else if (emailElement && !validateEmail(emailElement.value)) {
        emailElement.setAttribute(
          'data-error-message',
          'Please enter a valid email address',
        )
        showInputError(emailElement)
        hasErrors = true
      } else if (emailElement) {
        hideInputError(emailElement)
      }

      // Validate Phone
      if (!phoneElement?.value.trim()) {
        if (phoneElement) {
          phoneElement.setAttribute(
            'data-error-message',
            'Phone number is required',
          )
          showInputError(phoneElement)
          hasErrors = true
        }
      } else if (phoneElement && !validatePhoneNumber(phoneElement.value)) {
        phoneElement.setAttribute(
          'data-error-message',
          'Please enter a valid phone number',
        )
        showInputError(phoneElement)
        hasErrors = true
      } else if (phoneElement) {
        hideInputError(phoneElement)
      }

      // Validate SMS Consent
      if (!smsConsentElement?.checked) {
        if (smsConsentElement) {
          alert('You must consent to SMS terms to continue')
          hasErrors = true
        }
      }

      // Validate Terms Consent
      if (!termsConsentElement?.checked) {
        if (termsConsentElement) {
          alert('You must agree to the terms of service and privacy policy')
          hasErrors = true
        }
      }

      // If no errors, proceed with success
      if (!hasErrors) {
        // Hide the form
        const formContainer = document.getElementById('optin-form-container')
        const successMessage = document.getElementById('success-message')

        if (formContainer) {
          formContainer.style.display = 'none'
        }

        if (successMessage) {
          successMessage.style.display = 'block'
        }
      }
    })
  }
})
